import { useState } from "react";
import { Eye, Loader2, Lock, MessageCircle } from "lucide-react";
import { api, openChat } from "../../lib/api";
import { Reveal, Eyebrow } from "./Reveal";

export const Voyance = () => {
  const [paying, setPaying] = useState(false);
  const [payError, setPayError] = useState("");
  const pay = async () => {
    setPaying(true); setPayError("");
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key: "voyance_30", origin_url: window.location.origin, chat_sid: localStorage.getItem("wouffa_chat_session") });
      window.location.href = data.checkout_url;
    } catch { setPayError("Paiement momentanément indisponible. Réessayez ou passez par le chat."); setPaying(false); }
  };
  return (
    <section id="voyance" className="relative overflow-hidden bg-[#12100e] py-24 md:py-36" data-testid="voyance-section">
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[420px] w-[420px] rounded-full bg-amber-500/10 blur-[120px]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal><Eyebrow>Voyance haute puissance</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl leading-tight text-amber-50 sm:text-4xl lg:text-5xl">
              Consultation de Voyance en Direct
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base leading-relaxed text-stone-300 md:text-lg">
              Le Maître Wouffa lit votre situation de son œil spirituel : amour, travail, protection. Vous recevez des
              réponses claires et les actions à mener, directement dans le chat confidentiel.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <button onClick={() => openChat("Bonjour Maître, je souhaite une consultation de voyance. Ma question est : ")}
              data-testid="voyance-chat-button"
              className="mt-10 flex items-center gap-3 rounded-full border border-amber-500/60 px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] text-amber-200 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
              <MessageCircle className="h-4 w-4" /> Poser ma question dans le chat
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5 lg:col-start-8">
          <div className="rounded-3xl border border-amber-500/40 bg-[#181512] p-8 text-center shadow-[0_8px_40px_rgba(212,175,55,0.12)]" data-testid="voyance-card">
            <Eye className="mx-auto h-8 w-8 text-amber-400" />
            <p className="mt-4 font-serif-it text-2xl italic text-amber-100">Consultation privée</p>
            <p className="mt-6 font-display text-5xl text-amber-50">30€</p>
            <p className="mt-2 text-sm text-stone-300">payable par carte, après votre consultation</p>
            <button onClick={pay} disabled={paying} data-testid="voyance-pay-button"
              className="mt-7 flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-stone-950 transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50">
              {paying ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Payer les 30€ par carte
            </button>
            {payError && <p className="mt-3 text-xs text-red-400" data-testid="voyance-pay-error">{payError}</p>}
            <p className="mt-5 text-xs text-stone-400">Paiement sécurisé par Stripe · Aucun abonnement</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
